import React, { useState, useEffect } from 'react';
import { AppProvider, useApp } from './context/AppContext';
import { AuthScreen } from './components/AuthScreen';
import { Navbar } from './components/Navbar';
import { ResidentDashboard } from './components/ResidentDashboard';
import { StaffDashboard } from './components/StaffDashboard';
import { AdminDashboard } from './components/AdminDashboard';
import { SupabaseConfigModal } from './components/SupabaseConfigModal';

const MainContent: React.FC = () => {
  const { currentUser, selectedRole, authReady } = useApp();
  const [isSupabaseModalOpen, setIsSupabaseModalOpen] = useState(false);
  const [isInLIFF, setIsInLIFF] = useState(false);

  useEffect(() => {
    const checkLIFF = async () => {
      if (window.liff) {
        setIsInLIFF(window.liff.isInLIFFClient);
      }
    };
    checkLIFF();
  }, []);

  if (!authReady) {
    return <div className="min-h-screen flex items-center justify-center text-slate-500">กำลังตรวจสอบบัญชี…</div>;
  }

  if (!currentUser) {
    return (
      <>
        <AuthScreen onOpenSupabaseModal={() => setIsSupabaseModalOpen(true)} />
        <SupabaseConfigModal
          isOpen={isSupabaseModalOpen}
          onClose={() => setIsSupabaseModalOpen(false)}
        />
      </>
    );
  }

  return (
    <div className={`min-h-screen bg-slate-50 flex flex-col font-prompt selection:bg-blue-600 selection:text-white ${isInLIFF ? 'liff-mode' : ''}`}>
      {!isInLIFF && <Navbar onOpenSupabaseModal={() => setIsSupabaseModalOpen(true)} />}

      <main className="flex-1 pb-16">
        {selectedRole === 'resident' && <ResidentDashboard />}
        {selectedRole === 'staff' && <StaffDashboard />}
        {selectedRole === 'admin' && <AdminDashboard onOpenSupabaseModal={() => setIsSupabaseModalOpen(true)} />}
      </main>

      <SupabaseConfigModal
        isOpen={isSupabaseModalOpen}
        onClose={() => setIsSupabaseModalOpen(false)}
      />
    </div>
  );
};

export default function App() {
  return (
    <AppProvider>
      <MainContent />
    </AppProvider>
  );
}
